import React from "react";
import AdvanceTableWrapper from "../../components/AdvanceTableWrapper";
import AdvanceTableSearchBox from "../../components/AdvanceTableSearchBox";
import AdvanceTable from "../../components/AdvanceTable";
import AdvanceTablePagination from "../../components/AdvanceTablePagination";
import { Badge } from "react-bootstrap";
import PropTypes from "prop-types";

const ShortlinksList = ({ clickBadge, listShortLinks }) => {
  const columnsShortlinks = [
    {
      accessor: "shortlinks",
      Header: "Url Corta",
      Cell: (rowData) => {
        let rowInfo = rowData.row.original;
        return (
          <>
            <Badge
              onClick={() => {
                clickLink(rowInfo.shortlinks);
              }}
              bg="primary"
            >
              {rowInfo.displayname}
            </Badge>
          </>
        );
      },
    },
  ];

  const clickLink = (link) => {
    clickBadge(link);
  };
  return (
    <>
      {listShortLinks && (
        <AdvanceTableWrapper
          columns={columnsShortlinks}
          data={listShortLinks}
          sortable
          pagination
          perPage={5}
        >
          <AdvanceTableSearchBox table />

          <AdvanceTable
            table
            rowClassName="align-middle white-space-nowrap"
            tableProps={{
              size: "sm",
              striped: false,
              className: "fs--1 mb-0 overflow-hidden",
            }}
            printfooter={false}
            printHeader={false}
          />
          <AdvanceTablePagination table />
        </AdvanceTableWrapper>
      )}
    </>
  );
};
ShortlinksList.propTypes = {
  listShortLinks: PropTypes.array.isRequired,
  clickBadge: PropTypes.func.isRequired,
};

export default ShortlinksList;
